module.exports = __webpack_public_path__ + "img/usa-tuberculosis-female.0560b842.png";